"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _getRootNode = function getRootNode(element) {
  var rootNode = element.getRootNode();
  if (rootNode !== null && rootNode !== void 0 && rootNode.host) return _getRootNode(rootNode.host);
  return element;
};
var isInDOM = function isInDOM(element) {
  var _document$body, _document$body2;
  return !!element && (((_document$body = document.body) === null || _document$body === void 0 ? void 0 : _document$body.contains(element)) || ((_document$body2 = document.body) === null || _document$body2 === void 0 ? void 0 : _document$body2.contains(_getRootNode(element))));
};
var _default = exports["default"] = isInDOM;